import { ShieldAlert } from "lucide-react";
import { DISCLAIMER_SHORT } from "@/lib/site";

export default function DisclaimerBanner({ testid = "disclaimer-banner" }) {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: "var(--rr-surface-2)" }}
      data-testid={testid}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-10 sm:py-12 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8">
        <div
          className="flex items-center justify-center shrink-0 w-12 h-12 border"
          style={{ borderColor: "var(--rr-primary)", color: "var(--rr-primary)" }}
        >
          <ShieldAlert size={22} strokeWidth={1.5} />
        </div>
        <div>
          <p className="text-xs tracking-[0.2em] uppercase mb-2" style={{ color: "var(--rr-primary)" }}>
            This is not therapy
          </p>
          <p className="text-sm sm:text-base leading-relaxed max-w-4xl" style={{ color: "var(--rr-text)" }}>
            {DISCLAIMER_SHORT}
          </p>
        </div>
      </div>
    </section>
  );
}
